module.exports = {
	getAreaNameFromUrl(url) {
		const areas = [
			{ name: 'Admin', pattern: /\/admin\// },
			{ name: 'System admin', pattern: /\/system\// },
			{ name: 'Assessments', pattern: /assessment/ },
			{ name: 'Classroom view', pattern: /\/classrooms/ },
			{ name: 'Graphs', pattern: /graphs/ },
			{ name: 'Lesson plan', pattern: /lesson_plan/ },
			{ name: 'Progress monitor', pattern: /progress/ },
			{ name: 'Reports', pattern: /reports/ },
			{ name: 'Resources', pattern: /resources/ },
			{ name: 'Student information page', pattern: /students/ },
			{ name: 'Test scores', pattern: /test_scores/ },
			{ name: 'Video library', pattern: /video_library/ },
			{ name: 'Dashboard', pattern: /^\/$/ }
		];

		for (let area of Array.from(areas)) {
			if (url.match(area.pattern)) {
				return area.name;
			}
		}
	},

	serializeForQueryString(object, prefix) {
		const parameters = [];

		Object.keys(object).map(function(property) {
			if (object.hasOwnProperty(property)) {
				let parameter;
				const key = prefix ? `${ prefix }[${ property }]` : property;
				const value = object[property];

				if (value !== null && typeof value === 'object') {
					parameter = serializeForQueryString(value, key);
				} else {
					parameter = `${ encodeURIComponent(key) }=${ encodeURIComponent(value) }`;
				}

				return parameters.push(parameter);
			}
		});

		return parameters.join('&');
	}
};



// WEBPACK FOOTER //
// ./frontend/a2i/js/lib/urlHelper.js